/**
 * @description 获取地听公司海洋要素图层的url
 * @author zhb
 * @time 2020-01-28
 * @气压 http://58.215.175.29/ReadearthRest/GFS/2020/20200127/202001271200000_PRMSL/MapServer/tile/5/15/25
 * @风场 http://58.215.175.29/ReadearthRest/GFS/2020/20200127/202001271200000_WIND10M/MapServer/tile/5/12/25
 * @海浪 http://58.215.175.29/ReadearthRest/WW3/2020/20200127/202001271200000_WAVE/MapServer/tile/5/11/26
 * @表面洋流 http://58.215.175.29/ReadearthRest/SHOU/2020/20200127/20200127000000000_sf/MapServer/tile/5/12/26
 * @表温 http://58.215.175.29/ReadearthRest/SHOU/2020/20200126/20200126000000000_sst/MapServer/tile/5/13/26
 * @表温距平 http://58.215.175.29/ReadearthRest/SHOU/2019/20190611/20190611000000000_ssta/MapServer/tile/5/14/25
 * @海面高度 http://58.215.175.29/ReadearthRest/SHOU/2020/20200127/20200127000000000_ssh/MapServer/tile/5/15/25
 * @海面高度距平 http://58.215.175.29/ReadearthRest/SHOU/2019/20190613/20190613000000000_ssha/MapServer/tile/5/13/29
 * @叶绿素 http://58.215.175.29/ReadearthRest/SHOU/2020/20200113/20200113000000000_chla/MapServer/tile/5/14/25
 * @分层洋流 http://58.215.175.29/ReadearthRest/rtofs/2020/20200127/202001270000024_CURRENT50/MapServer/tile/5/12/26
 * @分层水温 http://58.215.175.29/ReadearthRest/rtofs/2020/20200126/202001260000024_TMP50/MapServer/tile/5/12/29
 * @锋面预警 http://58.215.175.29/ReadearthRest/fengxian/2012/201211/201211_fengxian/MapServer/tile/2/7/10
 * @风场预警 http://58.215.175.29/ReadearthRest/GFS/2020/20200127/202001271200000_WINDALARM/MapServer/tile/4/5/13
 * @海浪预警 http://58.215.175.29/ReadearthRest/WW3/2020/20200127/202001271200000_WAVEALARM/MapServer/tile/4/5/12
 */

/**
 * 接口迁移至新的服务器 地址相同，原本的9102 现在 9900
 */
import { Tile as TileLayer, Image as ImageLayer } from 'ol/layer'
import { XYZ, ImageWMS } from 'ol/source'

import moment from 'moment'
import { Message } from 'element-ui'
import { oceanlabIds_new as oceanlabIds } from './oceanIds'
//深度索引对应的真实深度 索引-1 就对应下标
export const depthMap = [0, 2, 4, 6, 8, 10, 12, 15, 20, 25, 30, 35, 40, 45, 50, 60, 70, 80, 90, 100, 125, 150, 200, 250, 300, 350, 400, 500, 600, 700, 800, 900, 1000, 1250, 1500, 2000, 2500, 3000, 4000, 5000]
var OceanType = {
    //气压
    PRMSL: 'GFS_PRMSL',
    //风场
    WIND10M: 'GFS_WIND10M',
    //海浪
    WAVE: 'WW3_WAVE',
    //海面洋流
    sf: 'SHOU_sf',
    //表温
    sst: 'SHOU_sst',
    //表温距平
    ssta: 'SHOU_ssta',
    //海面高度
    ssh: 'SHOU_ssh',
    //海面高度距平
    ssha: 'SHOU_ssha',
    //叶绿素
    chla: 'SHOU_chla',
    //分层洋流
    CURRENT50: 'rtofs_CURRENT50',
    //分层水温
    TMP50: 'rtofs_TMP50',
    //锋面预警
    fengxian: 'fengxian_fengxian',
    //风场预警
    WINDALARM: 'GFS_WINDALARM',
    //海浪预警
    WAVEALARM: 'WW3_WAVEALARM'
}

let timestamps = new Map()
timestamps.set('PRMSL', '1200000')
timestamps.set('WIND10M', '1200000')
timestamps.set('WAVE', '1200000')
timestamps.set('sf', '000000000')
timestamps.set('sst', '000000000')
timestamps.set('ssta', '000000000')
timestamps.set('ssh', '000000000')
timestamps.set('ssha', '000000000')
timestamps.set('chla', '000000000')
timestamps.set('CURRENT50', '0000024')
timestamps.set('CURRENT100', '0000024')
timestamps.set('CURRENT200', '0000024')
timestamps.set('CURRENT300', '000000002424')
timestamps.set('TMP50', '0000024')
timestamps.set('TMP100', '0000024')
timestamps.set('TMP200', '0000024')
timestamps.set('TMP300', '0000024')
timestamps.set('fengxian', '')
timestamps.set('WINDALARM', '1200000')
timestamps.set('WAVEALARM', '1200000')

let zIndexs = new Map()
zIndexs.set('PRMSL', 10)
zIndexs.set('WIND10M', 15)
zIndexs.set('WAVE', 1)
zIndexs.set('sf', 2)
zIndexs.set('sst', 3)
zIndexs.set('ssta', 4)
zIndexs.set('ssh', 5)
zIndexs.set('ssha', 6)
zIndexs.set('chla', 8)
zIndexs.set('CURRENT50', 9)
zIndexs.set('CURRENT100', 10)
zIndexs.set('CURRENT200', 11)
zIndexs.set('CURRENT300', 12)
zIndexs.set('TMP50', 13)
zIndexs.set('TMP100', 14)
zIndexs.set('TMP200', 15)
zIndexs.set('TMP300', 16)
zIndexs.set('fengxian', 17)
zIndexs.set('WINDALARM', 18)
zIndexs.set('WAVEALARM', 19)

let oRemarks = new Map()
oRemarks.set('PRMSL', '气压')
oRemarks.set('WIND10M', '风场')
oRemarks.set('WAVE', '海浪')
oRemarks.set('WAVEL', '海浪')
oRemarks.set('sf', '表面洋流')
oRemarks.set('sfP', '表面洋流')

oRemarks.set('sst', '表温')
oRemarks.set('sstL', '表温等值线')
oRemarks.set('ssta', '表温距平')
oRemarks.set('ssh', '海面高度')
oRemarks.set("sshL", '海面高度等值线')
oRemarks.set('ssha', '海面高度距平')
oRemarks.set('chla', '叶绿素')
oRemarks.set('CURRENT25', '分层洋流(25m)')
oRemarks.set('CURRENT50', '分层洋流(50m)')
oRemarks.set('CURRENT100', '分层洋流(100m)')
oRemarks.set('CURRENT150', '分层洋流(150m)')
oRemarks.set('CURRENT200', '分层洋流(200m)')
oRemarks.set('CURRENT300', '分层洋流(300m)')
oRemarks.set('CURRENT25P', '分层洋流(25m)')
oRemarks.set('CURRENT50P', '分层洋流(50m)')
oRemarks.set('CURRENT100P', '分层洋流(100m)')
oRemarks.set('CURRENT150P', '分层洋流(150m)')
oRemarks.set('CURRENT200P', '分层洋流(200m)')
oRemarks.set('CURRENT300P', '分层洋流(300m)')
oRemarks.set('TMP25', '分层水温(25m)')
oRemarks.set('TMP50', '分层水温(50m)')
oRemarks.set('TMP100', '分层水温(100m)')
oRemarks.set('TMP150', '分层水温(150m)')
oRemarks.set('TMP200', '分层水温(200m)')
oRemarks.set('TMP300', '分层水温(300m)')
oRemarks.set('TMP25L', '分层水温(25m)等值线')
oRemarks.set('TMP50L', '分层水温(50m)等值线')
oRemarks.set('TMP100L', '分层水温(100m)等值线')
oRemarks.set('TMP150L', '分层水温(150m)等值线')
oRemarks.set('TMP200L', '分层水温(200m)等值线')
oRemarks.set('TMP300L', '分层水温(300m)等值线')
oRemarks.set('fengxian', '锋面预警')
oRemarks.set('WINDALARM', '风场预警')
oRemarks.set('WAVEALARM', '海浪预警')
    //oceanlab id的对应表


let dtocean = {
    oceanLabDataInfo: oceanlabIds,
    oRemarks: oRemarks,
    /**
     * 获取海洋环境要素地图服务url
     * @param {*} oceanType
     * @param {*} oceanDate
     */
    getUrl: function(oceanType, oceanDate) {
        var url = ''

        var _baseUrl = 'http://58.215.175.29/ReadearthRest/'
        oceanDate = oceanDate || new Date()
        oceanType = oceanType || OceanType.PRMSL
        var omArgs = oceanType.split('_')
        if (oceanDate instanceof String) {
            oceanDate = this._convertDate(oceanDate)
        }
        ///模式类型
        var mType = omArgs[0]
            //海洋要素类型
        var oType = omArgs[1]
        var years = oceanDate.getFullYear() + ''
            //getMothod()从0开始排序
        var months = oceanDate.getMonth() + 1
        months = months > 9 ? months + '' : '0' + months
        var days = oceanDate.getDate()
        days = days > 9 ? days + '' : '0' + days
        let timestamp = timestamps.get(oType)
        url =
            _baseUrl +
            mType +
            '/' +
            years +
            '/' +
            years +
            months +
            days +
            '/' +
            years +
            months +
            days +
            timestamp +
            '_' +
            oType +
            '/MapServer/tile/{z}/{y}/{x}'
        return url
    },
    /**
     * 转换字符串为Date对象
     * @param {*} dateStr
     */
    _convertDate: function(dateStr) {
        var ret = null
        if (dateStr instanceof String) {
            if (dateStr.length >= 10) {
                //转换后为毫秒
                var millsec = Date.parse(dateStr)
                var currentDate = new Date()
                currentDate.setTime(millsec)
                ret = currentDate
            }
        }
        return ret
    },
    //获取layer图层
    getTilelayer: function(oceanType, oceanDate) {
        // //debugger
        let layer = null
        let url = this.getUrl(oceanType, oceanDate)

        let testUrl = url
            .replace('{z}', '5')
            .replace('{y}', '13')
            .replace('{x}', '29')
            //检验当前图层是否有数据
        let img = new Image()
        img.src = testUrl
        img.onload = event => {
            img = null
        }
        img.onerror = err => {
                img = null
                var omArgs = oceanType.split('_')
                Message.error(
                    `${moment(oceanDate).format('YYYY年MM月DD')} 无 "${oRemarks.get(
          omArgs[1]
        )}" 数据`
                )
            }
            ///

        layer = new TileLayer({
            source: new XYZ({
                url: url
            }),
            zIndex: 10
        })
        return layer
    },
    getNcJsonUrl: function(stime) {
        var dt_starttime_new = new Date(stime)
        var itime = '',
            ftime = ''
        itime = ftime = moment(dt_starttime_new).format('YYYYMMDDHH0000')
        var windPath =
            'http://202.96.202.170/api/eds/' +
            'geojson?ftime=' +
            (ftime || page_ftime) +
            '&itime=' +
            page_itime +
            '&model_name=' +
            (page_model_name || 'ncep_gfs') +
            '&variable_name=' +
            (page_variable_code || 'UGRD_10maboveground,VGRD_10maboveground') +
            ''
    },
    /**
     * 获取oceanslab单点查询数据
     * @param {图层名称} layerId
     * @param {开始时间} stime
     * @param {地图范围} bbox
     * @param {地图界面宽度} screenW
     * @param {地面界面高度} screenH
     * @param {点击的屏幕X坐标} screenX
     * @param {点击的屏幕Y坐标} screenY
     */
    getOceansLabPointUrl_old(
        layerName,
        stime,
        bbox,
        screenW,
        screenH,
        screenX,
        screenY
    ) {
        // //debugger

        if (!(layerName instanceof Array)) {
            layerName = layerName.split(',')
        }
        let layerId = []
        let zlayer = []
        let timepoint = 0
        layerName.forEach(item => {
            if (oceanlabIds.has(item.name)) {
                let oceanLab = oceanlabIds.get(item.name)
                layerId.push(oceanLab.layerId)
                    // if (oceanLab.zLayer !== 0) {
                    // if (zlayer[0] === 0) {
                    //     zlayer = [];
                    // }
                timepoint = item.time
                zlayer.push(oceanLab.zLayer)
                    // }
            }
        })

        let itime = moment(stime)
            .add(timepoint, 'hours')
            .format('YYYY-MM-DDTHH:mm:ss')
            // http://readearth2014.vicp.cc:9104/webservice_ECSFH5/wms.aspx?ServiceName=ecsf:ecsf&time=2019-03-17T00:00:00&exceptions=application/xml&format=application/xml&styles=&srs=EPSG:3857&version=1.1.1&layers=100103&request=GETFEATUREINFO&BBOX=14898799.805233413%2C2517224.2154874243%2C16073484.055920003%2C3113433.036111799&crs=EPSG:3857&transparent=true&width=1660&service=WMS&height=931&X=1000&Y=600&zlayer=1
        let url = `http://diting.kmdns.net:9900/WebService_Staging/api/v1/mapservice/drawEds?token=101_qdkc26272MT936&ServiceName=aquatic_admin:eastchinaseaAquatic&time=${itime}&exceptions=application/vnd.ogc.se_inimage&format=image/png&styles=&srs=EPSG:3857&version=1.1.1&layers=${layerId.join()}&request=GETFEATUREINFO&bbox=${bbox}&crs=EPSG:3857&transparent=true&width=${screenW}&service=WMS&height=${screenH}&X=${screenX}&Y=${screenY}&zlayer=${zlayer.join()}`
        return url
    },
    // getOceansLabPointUrlObj(layerName, stime, etime, coord) {
    //     if (typeof layerName == 'string') {
    //         layerName = [{ name: layerName, }]
    //     } else if (!Array.isArray(layerName)) {
    //         layerName = [layerName]
    //     }
    //     let layerId = []
    //     let objs = []
    //     layerName.forEach(item => {
    //         if (oceanlabIds.has(item.name)) {
    //             let oceanLab = oceanlabIds.get(item.name)
    //             layerId.push(oceanLab.layerId)
    //                 // if (oceanLab.zLayer !== 0) {
    //                 // if (zlayer[0] === 0) {
    //                 //     zlayer = [];
    //                 // }
    //             objs.push({
    //                     layerID: oceanLab.layerId,
    //                     startTime: stime,
    //                     endTime: etime,
    //                     isTimeRange: true,
    //                     wktStr: `POINT(${coord[0]} ${coord[1]})`,
    //                     zLayer: item.zlayers || [oceanLab.zlayer || 0]

    //                 })
    //                 // }
    //         }
    //     })
    //     return {
    //         url: "http://diting.kmdns.net:9900/WebService_Staging/api/v1/AnalysisInfo/EDSDataQuery/FileQuery/",
    //         json: JSON.stringify(objs)

    //     }

    // },
    getOceansLabPointUrlObj(layerName, stime, etime, coord, timeRange = false) {
        // let oceanlabIds = oceanlabIds_new
        if (typeof layerName == 'string') {
            layerName = [{ name: layerName, }]
        } else if (!Array.isArray(layerName)) {
            layerName = [layerName]
        }
        let layerId = []
        let objs = []
        layerName.forEach(item => {
            if (oceanlabIds.has(item.name)) {
                let oceanLab = oceanlabIds.get(item.name)
                layerId.push(oceanLab.layerId)
                    // if (oceanLab.zLayer !== 0) {
                    // if (zlayer[0] === 0) {
                    //     zlayer = [];
                    // }
                if (timeRange) {
                    // 时间范围查询
                    objs.push({
                        layerID: oceanLab.layerId,
                        startTime: item.time || stime,
                        endTime: item.time || etime,
                        isTimeRange: true,
                        wktStr: `POINT(${coord[0]} ${coord[1]})`,
                        zLayer: item.zlayers || [oceanLab.zlayer || 0]

                    })
                } else {
                    // 单个时间查询
                    objs.push({
                        layerID: oceanLab.layerId,
                        time: item.time || stime,
                        isTimeRange: false,
                        wktStr: `POINT(${coord[0]} ${coord[1]})`,
                        zLayer: item.zlayers || [oceanLab.zlayer || 0]

                    })
                }

                // }
            }
        })
        return {
            url: "http://diting.kmdns.net:9900/WebService_Staging/api/v1/AnalysisInfo/EDSDataQuery/FileQuery/",
            json: JSON.stringify(objs)

        }

    },
    /**
     * 获取oceanslab时间序列
     * @param {图层名称} layerId
     * @param {开始时间} stime
     * @param {预报时间，默认7天} days
     * @param {地图范围} bbox
     * @param {地图界面宽度} screenW
     * @param {地面界面高度} screenH
     * @param {点击的屏幕X坐标} screenX
     * @param {点击的屏幕Y坐标} screenY
     * @param {图层深度} zlayer
     */
    getOceansLabTimeForecastUrl(
        layerName,
        stime,
        days,
        bbox,
        screenW,
        screenH,
        screenX,
        screenY,
        zlayer
    ) {
        if (oceanlabIds.has(layerName)) {
            let oceanLab = oceanlabIds.get(layerName)
            let layerId = oceanLab.layerId
            zlayer = zlayer || oceanLab.zLayer
            let iyear = moment(stime).years()
            let time = iyear < 2019 ? '00:00:00' : oceanLab.time
            days = days || 7
            let itime = moment(stime).format('YYYY-MM-DDT') + time
            let etime = moment(stime)
                .add(days, 'days')
                .format('YYYY-MM-DDT00:00:00')
                // http: //readearth2014.vicp.cc:9104/webservice_ECSFH5/wms.aspx?ServiceName=ecsf:ecsf&time=2019-03-12T00:00:00/2019-03-17T00:00:00/P24H&exceptions=application/json&format=application/xml&styles=&srs=EPSG:3857&version=1.1.1&layers=100103&request=GETFEATUREINFO&BBOX=14898799.805233413%2C2517224.2154874243%2C16073484.055920003%2C3113433.036111799&crs=EPSG:3857&transparent=true&width=1660&service=WMS&height=931&X=1000&Y=600&zlayer=1
                // http://readearth2014.vicp.cc:9104/webservice_ECSFH5/WMS.aspx?ServiceName=ECSF:ECSF&time=2020-03-17T00:00:00/2020-03-22T00:00:00&exceptions=application/vnd.ogc.se_inimage&format=application/json&styles=&srs=EPSG:3857&version=1.1.1&layers=100099&request=GETFEATUREINFO&bbox=6984647.151364545,1954209.2213722898,23225986.92139448,11063057.008057754&crs=EPSG:3857&transparent=true&width=1660&service=WMS&height=931&X=10&Y=10
                // let url = `http://readearth2014.vicp.cc:9104/webservice_ECSFH5/wms.aspx?ServiceName=ecsf:ecsf&time=${itime}/${etime}/P24H&exceptions=application/json&format=application/xml&styles=&srs=EPSG:3857&version=1.1.1&layers=${layerId}&request=GETFEATUREINFO&BBOX=${bbox}&crs=EPSG:3857&transparent=true&width=${screenW}&service=WMS&height=${screenH}&X=${screenX}&Y=${screenY}&zlayer=${zlayer}
            let url = `http://diting.kmdns.net:9900/WebService_Staging/api/v1/mapservice/drawEds?token=101_qdkc26272MT936&ServiceName=ECSF:ECSF&time=${itime}/${etime}&exceptions=application/vnd.ogc.se_inimage&format=application/json&styles=&srs=EPSG:3857&version=1.1.1&layers=${layerId}&request=GETFEATUREINFO&bbox=${bbox}&crs=EPSG:3857&transparent=true&width=${screenW}&service=WMS&height=${screenH}&X=${screenX}&Y=${screenY}&zlayer=${zlayer}`
            return url
        }
    },

    /**
     * 获取oceanslab的图层url
     * @param {图层名称} layerName
     * @param {开始时间} stime
     * @param {预报时间 @tyep int} ftime
     */
    getOceanLabLayer(layerName, stime, ftime) {
        debugger
        if (!layerName) return null
        var omArgs = layerName.split('_')
            ///模式类型
        var mType = omArgs[0]
            //海洋要素类型
        var oType = omArgs[1]
        if (oceanlabIds.has(oType)) {
            let oceanLab = oceanlabIds.get(oType)
            let layerId = oceanLab.layerId
            let zlayer = oceanLab.zLayer
            let iyear = moment(stime).years()
            let time = iyear < 2019 ? '00:00:00' : oceanLab.time
            let datetime = moment(moment(stime).format('YYYY-MM-DD ') + time)
            let hours = datetime.hours()
            let preDatetime = datetime.subtract(hours, 'hours')
            let itime = preDatetime.add(ftime, 'hours').format('YYYY-MM-DDTHH:mm:ss')
                //新服务器新增styles 参数
            let styles = oceanLab.styles || ''
            console.log('olab', oceanLab, layerName)
            let url = `http://diting.kmdns.net:9900/WebService_Staging/api/v1/mapservice/drawEds?token=101_qdkc26272MT936&zlayer=${zlayer}&ServiceName=ECSF:ECSF&time=${itime}&service=WMS&styles=${styles}&bbox=17902486.36915615,2678536.307909463,18595316.18026975,3035022.1196523276&format=image/png&version=1.1.1&srs=EPSG:3857&exceptions=application/vnd.ogc.se_inimage&crs=EPSG:3857&request=GetMap&transparent=true&width=2855&layers=${layerId}&height=1469`
                //检验当前图层是否有数据
            let img = new Image()
            img.src = url
            img.onload = event => {
                img = null
            }
            img.onerror = err => {
                img = null
                var omArgs = layerName.split('_')
                Message.error(
                    `${moment(itime).format('YYYY年MM月DD')} 无 "${oRemarks.get(
            omArgs[1]
          )}" 数据`
                )
            }

            let WMS = new ImageLayer({
                source: new ImageWMS({
                    url: 'http://diting.kmdns.net:9900/WebService_Staging/api/v1/mapservice/drawEds?token=101_qdkc26272MT936&zlayer=' +
                        zlayer,
                    params: {
                        LAYERS: layerId,
                        TILED: false, //是否要将数据制作成切片，省略后返回的是一张完整图。,
                        time: itime,
                        styles: styles
                    },
                    // serverType: 'geoserver',
                    projection: 'EPSG:3857',
                    crossOrigin: 'anonymous'
                })
            })
            return WMS
        }

    },
    /**
     * 获取oceanslab的图层url
     * @param {图层名称} layerName
     * @param {开始时间} stime
     * @param {预报时间 @tyep int} ftime
     */
    getOceanLabLayerUrl(layerName, stime, ftime) {
        var omArgs = layerName.split('_')
            ///模式类型
        var mType = omArgs[0]
            //海洋要素类型
        var oType = omArgs[1]
        if (oceanlabIds.has(oType)) {
            let oceanLab = oceanlabIds.get(oType)
            let layerId = oceanLab.layerId
            let zlayer = oceanLab.zLayer
            let iyear = moment(stime).years()
            let time = iyear < 2019 ? '00:00:00' : oceanLab.time
            let datetime = moment(moment(stime).format('YYYY-MM-DD ') + time)
            let hours = datetime.hours()
            let preDatetime = datetime.subtract(hours, 'hours')
            let itime = preDatetime.add(ftime, 'hours').format('YYYY-MM-DDTHH:mm:ss')
                // let itime = moment(moment(stime).format("YYYY-MM-DD ") + time).add(ftime, 'hours').format("YYYY-MM-DDTHH:mm:ss");
            let styles = oceanLab.styles || ''

            let url = `http://diting.kmdns.net:9900/WebService_Staging/api/v1/mapservice/drawEds?token=101_qdkc26272MT936&zlayer=${zlayer}&ServiceName=ECSF:ECSF&time=${itime}&service=WMS&styles=${styles}&bbox=17902486.36915615,2678536.307909463,18595316.18026975,3035022.1196523276&format=image/png&version=1.1.1&srs=EPSG:3857&exceptions=application/vnd.ogc.se_inimage&crs=EPSG:3857&request=GetMap&transparent=true&width=2855&layers=${layerId}&height=1469`
                //检验当前图层是否有数据
            let img = new Image()
            img.src = url
            img.onload = event => {
                img = null
            }
            img.onerror = err => {
                img = null
                var omArgs = layerName.split('_')
                Message.error(
                    `${moment(itime).format('YYYY年MM月DD')} 无 "${oRemarks.get(
            omArgs[1]
          )}" 数据`
                )
            }

            let WMS = {
                url: 'http://diting.kmdns.net:9900/WebService_Staging/api/v1/mapservice/drawEds?token=101_qdkc26272MT936&zlayer=' +
                    zlayer,
                params: {
                    LAYERS: layerId,
                    TILED: false, //是否要将数据制作成切片，省略后返回的是一张完整图。,
                    time: itime,
                    styles: styles
                },
                // serverType: 'geoserver',
                projection: 'EPSG:3857'
            }
            return WMS
        }
    },
    /**
     * 获取oceanslab的图片url
     * @param {图层名称} layerName
     * @param {开始时间} stime
     * @param {预报时间 @tyep int} ftime
     * @param {范围 @tyep string} bbox
     * @param {宽度 @tyep int} width
     * @param {高度 @tyep int} height
     */
    getOceanLabLayerImageUrl(layerName, itime, bbox, width, height) {
        var omArgs = layerName.split('_')
            ///模式类型
        var mType = omArgs[0]
            //海洋要素类型
        var oType = omArgs[1]
        if (oceanlabIds.has(oType)) {
            let oceanLab = oceanlabIds.get(oType)
            let layerId = oceanLab.layerId
            let zlayer = oceanLab.zLayer
                // let time = oceanLab.time;
            let datetime = moment(itime)
                // let hours = datetime.hours();
                // let preDatetime = datetime.subtract(hours, 'hours')
            itime = datetime.format('YYYY-MM-DDTHH:mm:ss')
                // let itime = moment(moment(stime).format("YYYY-MM-DD ") + time).add(ftime, 'hours').format("YYYY-MM-DDTHH:mm:ss");
            let styles = oceanLab.styles || ''

            let url = `http://diting.kmdns.net:9900/WebService_Staging/api/v1/mapservice/drawEds?token=101_qdkc26272MT936&zlayer=${zlayer}&ServiceName=ECSF:ECSF&time=${itime}&service=WMS&styles=${styles}&bbox=${bbox}&format=image/png&version=1.1.1&srs=EPSG:3857&exceptions=application/vnd.ogc.se_inimage&crs=EPSG:3857&request=GetMap&transparent=true&width=${width}&layers=${layerId}&height=${height}`
            return url
        }
    },

    /**
     * 按照范围获取数据url，以图片的形式传输数据
     * @param {*} layerName
     * @param {*} stime
     * @param {范围（xmin,ymin,xmax,ymax）} extent
     */
    getOceanLabDataForImageUrl(layerName, stime, ftime, extent) {
        var omArgs = layerName.split('_')
            ///模式类型
        var mType = omArgs[0]
            //海洋要素类型
        var oType = omArgs[1]
        if (oceanlabIds.has(oType)) {
            let oceanLab = oceanlabIds.get(oType)
            let layerId = oceanLab.layerId
            let zlayer = oceanLab.zLayer
            let iyear = moment(stime).years()
            let time = iyear < 2019 ? '00:00:00' : oceanLab.time
            let itime = moment(moment(stime).format('YYYY-MM-DD ') + time)
                .add(ftime || 0, 'days')
                .format('YYYY-MM-DDTHH:mm:ss')

            let url = `http://diting.kmdns.net:9900/WebService_Staging/api/v1/mapservice/drawEds?token=101_qdkc26272MT936&zlayer=${zlayer}&SERVICE=WMS&VERSION=1.3.0&REQUEST=GetData&FORMAT=image/png&TRANSPARENT=true&LAYERS=${layerId}&TILED=false&time=${itime}&CRS=EPSG:4326&STYLES=&BBOX=${extent}`
            return url
        }
    },
    /**
     * 
     */
    getParticleImageUrl(itime) {
        return `http://diting.kmdns.net:9900/WebService_Staging/api/v1/mapservice/wms/eds/ecsf:ecsf?zlayer=1&SERVICE=WMS&VERSION=1.3.0&REQUEST=GetData&FORMAT=image/png&TRANSPARENT=true&TILED=false&CRS=EPSG:4326&STYLES=&BBOX=0,-77,360,77&WIDTH=1920&HEIGHT=1080&LAYERS=3&time=${itime}`
    },
    getZindexs() {
        return zIndexs
    },
    baseOrigin: 'http://diting.kmdns.net:9900'
}

export default dtocean


// WEBPACK FOOTER //
// ./src/utils/map/oceanLayers.js